<template>
  <v-container class="mt-12">
    <!-- Title -->
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-card class="pa-6">
          <v-card-title>
            <h2 class="text-center">Evaluate Dorakk Performance</h2>
          </v-card-title>
          <v-divider></v-divider>

          <!-- Form Section -->
          <v-card-text>
            <v-form ref="formRef" @submit.prevent="submitFiles">
              <!-- Reference Audio -->
              <v-file-input
                  label="Upload Reference Audio"
                  outlined
                  dense
                  accept="audio/*"
                  v-model="referenceFile"
                  prepend-icon="mdi-music-note"
              ></v-file-input>

              <!-- Your Performance -->
              <v-file-input
                  label="Upload Your Performance"
                  outlined
                  dense
                  accept="audio/*"
                  v-model="childFile"
                  prepend-icon="mdi-music-circle"
              ></v-file-input>

              <!-- Weights -->
              <v-row dense>
                <v-col cols="12">
                  <h3 class="mb-2">Set Weights</h3>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                      label="Timing Weight"
                      type="number"
                      v-model="weights.timing"
                      outlined
                      dense
                      prepend-icon="mdi-clock-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                      label="Loudness Weight"
                      type="number"
                      v-model="weights.loudness"
                      outlined
                      dense
                      prepend-icon="mdi-volume-high"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                      label="Timbre Weight"
                      type="number"
                      v-model="weights.timbre"
                      outlined
                      dense
                      prepend-icon="mdi-tune"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                      label="Brightness Weight"
                      type="number"
                      v-model="weights.brightness"
                      outlined
                      dense
                      prepend-icon="mdi-brightness-7"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Max Errors -->
              <v-row dense>
                <v-col cols="12">
                  <h3 class="mb-2">Set Max Errors</h3>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                      label="Timing Max Error (ms)"
                      type="number"
                      v-model="maxErrors.timing_ms"
                      outlined
                      dense
                      prepend-icon="mdi-timer-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                      label="Loudness Max Error (dB)"
                      type="number"
                      v-model="maxErrors.loudness_db"
                      outlined
                      dense
                      prepend-icon="mdi-decibel"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                      label="Timbre Max Error"
                      type="number"
                      v-model="maxErrors.timbre_dist"
                      outlined
                      dense
                      prepend-icon="mdi-chart-bubble"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                      label="Brightness Max Error"
                      type="number"
                      v-model="maxErrors.brightness"
                      outlined
                      dense
                      prepend-icon="mdi-brightness-7"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Submit Button -->
              <v-btn color="primary" block class="mt-4 mb-4" type="submit">
                <v-icon left>mdi-console-line</v-icon>
                Evaluate Performance
              </v-btn>
            </v-form>

            <!-- Display Result -->
            <v-alert
                v-if="score !== null"
                class="mt-4"
                type="success"
                border="left"
                elevation="2"
            >
              <h3>Your Score: <strong>{{ score.toFixed(2) }}</strong> / 10</h3>
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  data() {
    return {
      referenceFile: null,
      childFile: null,
      score: null,
      weights: {
        timing: 0.45, // Default Value
        loudness: 0.25, // Default Value
        timbre: 0.2, // Default Value
        brightness: 0.1, // Default Value
      },
      maxErrors: {
        timing_ms: 500, // Default Value
        loudness_db: 100, // Default Value
        timbre_dist: 125000, // Default Value
        brightness: 5000, // Default Value
      },
    };
  },
  methods: {
    async submitFiles() {
      const formData = new FormData();
      formData.append("reference", this.referenceFile);
      formData.append("child", this.childFile);

      // Append weights as individual array items
      Object.keys(this.weights).forEach((key) => {
        formData.append(`weights[${key}]`, this.weights[key]);
      });

      // Append max_errors as individual array items
      Object.keys(this.maxErrors).forEach((key) => {
        formData.append(`max_errors[${key}]`, this.maxErrors[key]);
      });

      try {
        const response = await window.axios.post("/test", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.score = response.data.score;
      } catch (error) {
        console.error(error);
        this.$alert("An error occurred while evaluating the performance.", "Error", {
          confirmButtonText: "OK",
        });
      }
    },
  },
};
</script>

<style scoped>
/* Custom optional styles if needed */
</style>
